import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {
  selectBackgroundColor,
  selectFabricArt,
  selectSelectedBackground,
} from '~/CreateFabricGreetingCard/reducers/fabricDesign/selectors';
import {DisabledWarning} from '~/CreateFabricGreetingCard/routes/EGiftCard/components/DisabledWarning/DisabledWarning';
import {NavBottom} from '~/common/fabric/Card/components/NavBottom/NavBottom';
import {PreviewCard} from '~/common/fabric/Card/components/PreviewCard/PreviewCard';
import {
  selectIsDrawerOpen,
  selectSystemDisabled,
  selectUserOrSystemDisabled,
} from '~/common/fabric/GiftCard/reducers/eGiftCard/selectors';
import {selectSender} from '~/common/fabric/reducers/review/selectors';
import {useIsLargishAndUp} from '~/common/hooks/useMatchQuery';
import EditRetailer from './components/EditRetailer/EditRetailer';
import {GiftCard} from './components/GiftCard/GiftCard';

import './EGiftCard.sass';

const DefaultPreviewElement = () => {
  const fabricArt = useSelector(selectFabricArt);
  const backgroundColor = useSelector(selectBackgroundColor);
  const background = useSelector(selectSelectedBackground);
  const senderName = useSelector(selectSender);
  const isDesktop = useIsLargishAndUp();

  return (
    <PreviewCard
      background={background}
      backgroundColor={backgroundColor}
      fabricArt={fabricArt}
      message="Optional: Write your customized message here in a later step."
      userName={senderName}
      isMobile={!isDesktop}
      hidePreviewContactInfo={false}
      previewPanelClassName="gift-card-preview"
      initCardFlipped={false}
    />
  );
};

const DefaultBottomNavElement = () => {
  const userOrSystemDisabled = useSelector(selectUserOrSystemDisabled);

  return (
    <NavBottom
      customNextButtonText={userOrSystemDisabled ? 'Skip & continue' : 'Next: Add recipient(s)'}
      ctaVariant={userOrSystemDisabled ? 'secondary' : 'primary'}
    />
  );
};

export const EGiftCard = ({
  PreviewElement = <DefaultPreviewElement />,
  BottomNavElement = <DefaultBottomNavElement />,
}) => {
  const isDrawerOpen = useSelector(selectIsDrawerOpen);
  const systemDisabled = useSelector(selectSystemDisabled);
  const isDesktop = useIsLargishAndUp();

  const ContainerContent = useMemo(() => {
    if (systemDisabled) return <DisabledWarning />;
    if (isDrawerOpen) return <EditRetailer />;
    return (
      <div className="gift-card-container__inner__content">
        <GiftCard />
      </div>
    );
  }, [systemDisabled, isDrawerOpen]);

  return (
    <>
      {isDesktop ? PreviewElement : null}

      <div
        className={`gift-card-container ${
          isDrawerOpen ? 'edit-retailer' : ''
        } create-flow__options`}
      >
        <div className="gift-card-container__inner">{ContainerContent}</div>
        {BottomNavElement}
      </div>
    </>
  );
};
